module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/monochrome_instagram_icon-28c0e5c89a211ef52384277ee16b73ab.png";